import React from "react";
import CreateClients from "./CreateClients";
import CreateClientsMobiles from "./CreateClientsMobiles";

const PageCreateClients = () => {
    return (

        <div className="h-full">
            <CreateClients />
        </div>
    )
}
export default PageCreateClients;